// Shapes the server's revenue rows (GET /orders daily_revenue and
// /orders/monthly-revenue) for the Sales chart, which stacks one-off,
// subscription and trade revenue. `revenue` from the server is the whole
// total; subscriptionRevenue and tradeRevenue are parts of it.
import moment from 'moment';

const round2 = (n) => Math.round(n * 100) / 100;

const EMPTY_DAY = {
  revenue: 0, orderCount: 0, oneOffCount: 0, subscriptionDeliveryCount: 0, subscriptionRevenue: 0,
  tradeRevenue: 0, tradeDeliveryCount: 0,
};

// One row per day for the last `days` days, today included.
export const fillMissingDays = (data, days, now = moment()) => {
  const filled = [];
  for (let i = days - 1; i >= 0; i--) {
    const date = moment(now).subtract(i, 'days').format('YYYY-MM-DD');
    const existing = data.find(d => d._id === date);
    filled.push(existing || { _id: date, ...EMPTY_DAY });
  }
  return filled;
};

// splits revenue into the one-off, subscription and trade areas the chart stacks
export const withRevenueSplit = (rows) => rows.map(r => ({
  ...r,
  subscriptionRevenue: r.subscriptionRevenue || 0,
  // trade (wholesale) invoices; older server builds don't send it
  tradeRevenue: r.tradeRevenue || 0,
  oneOffRevenue: round2((r.revenue || 0) - (r.subscriptionRevenue || 0) - (r.tradeRevenue || 0)),
  // subscription deliveries/charges aren't customer orders; older server
  // builds don't send oneOffCount, so fall back to the raw count
  oneOffCount: r.oneOffCount ?? r.orderCount ?? 0,
  // chart's Orders line: one-off orders plus subscription and trade deliveries
  // (not signups or month-end bills - the server only counts deliveries)
  ordersInclSubs: (r.oneOffCount ?? r.orderCount ?? 0) + (r.subscriptionDeliveryCount || 0) + (r.tradeDeliveryCount || 0),
}));
